/**
 * Libellés des statuts de commande, pour l'admin.
 *
 * Le statut le plus important est `pending_shipping` : il est écrit par le
 * webhook quand le paiement a réussi mais que Sendcloud n'a PAS créé
 * l'étiquette (voir checkout_processing_service.ts). Autrement dit : le client
 * a payé, le colis n'est pas prêt à partir, et personne n'est prévenu.
 *
 * Il s'affichait comme les autres — une pastille grise portant le texte brut
 * « pending_shipping ». Grise, en anglais, au milieu de commandes payées : rien
 * ne signalait qu'il fallait agir. C'est le seul statut qui demande une action
 * manuelle, il doit donc se voir immédiatement.
 */
const STATUTS = {
  paid: { libelle: 'Payée', classe: 'bg-green-100 text-green-800' },
  pending: { libelle: 'En attente de paiement', classe: 'bg-yellow-100 text-yellow-800' },
  pending_shipping: {
    libelle: '⚠️ Étiquette à créer',
    classe: 'bg-red-100 text-red-800 font-bold',
  },
  cancelled: { libelle: 'Annulée', classe: 'bg-gray-100 text-gray-800' },
  refunded: { libelle: 'Remboursée', classe: 'bg-gray-100 text-gray-800' },
};

const PAR_DEFAUT = { classe: 'bg-gray-100 text-gray-800' };

/** Libellé lisible d'un statut ; à défaut, le statut brut plutôt que rien. */
export function libelleStatut(statut) {
  const cle = String(statut || '').toLowerCase();
  return STATUTS[cle]?.libelle || statut || '—';
}

/** Classes Tailwind de la pastille correspondante. */
export function classeStatut(statut) {
  const cle = String(statut || '').toLowerCase();
  return (STATUTS[cle] || PAR_DEFAUT).classe;
}

/** Cette commande réclame-t-elle une action manuelle ? */
export function demandeUneAction(statut) {
  return String(statut || '').toLowerCase() === 'pending_shipping';
}
